import { RotateCw, TriangleAlert } from "lucide-react";

export function ErrorState({
	message,
	onRetry,
	className = "",
}: {
	message: string;
	onRetry?: () => void;
	className?: string;
}) {
	return (
		<div
			className={`flex flex-wrap items-center gap-2.5 rounded-[10px] border border-fault/40 bg-fault/[0.06] px-3 py-2 text-[13px] ${className}`}
			role="alert"
		>
			<TriangleAlert className="size-4 shrink-0 text-fault" aria-hidden />
			<span className="min-w-0 flex-1 font-medium break-words text-fault">{message}</span>
			{onRetry && (
				<button
					type="button"
					onClick={onRetry}
					className="inline-flex min-h-tap items-center gap-1.5 rounded-md border border-hairline bg-paper px-2.5 text-xs font-medium text-ink hover:border-line hover:bg-raised"
				>
					<RotateCw className="size-3.5" aria-hidden />
					Retry
				</button>
			)}
		</div>
	);
}
